import Vue from 'vue'
import App from './App.vue'
import {firestorePlugin} from 'vuefire';
import router from './router';
import VueI18n from "vue-i18n";
import messages from "@/messages";

Vue.use(firestorePlugin);
Vue.use(VueI18n);
Vue.config.productionTip = false;

const i18n = new VueI18n({
    locale: 'en',
    messages,
});

new Vue({
    router,
    i18n,
    data: { theme: 'default' },
    computed: {
        isEnneagram() {
            return this.$root.theme === 'enneagram';
        }
    },
    created() {
        this.$root.theme = this.$route.query.theme || 'default'
    },
    render: h => h(App),
}).$mount('#app')
